import { useMemo } from "react";

import { useGlobalStore } from "@/stores/global";
import { ORG_ROLE, OrgRole, WORKSPACE_ROLE, WorkspaceRole } from "@/types/user";

interface RolesState {
  // Role values
  orgRole: OrgRole | null;
  workspaceRole: WorkspaceRole | null;

  // Org role checks
  isOrgAdmin: boolean;
  isOrgMember: boolean;

  // Workspace role checks
  isWorkspaceAdmin: boolean;
  isWorkspaceMember: boolean;
  isWorkspaceAgent: boolean;
}

export const useRoles = (): RolesState => {
  const loggedInUser = useGlobalStore((state) => state.loggedInUser);
  const activeWorkspaceId = useGlobalStore((state) => state.activeWorkspaceId);

  return useMemo(() => {
    const orgRole = loggedInUser?.role ?? "organization:admin";
    const workspaceRole =
      loggedInUser?.workspaces?.find((w) => w.id === activeWorkspaceId)?.role ??
      "workspace:admin";

    return {
      // Role values
      orgRole,
      workspaceRole,

      // Org role checks
      isOrgAdmin: orgRole === ORG_ROLE.ADMIN,
      isOrgMember: orgRole === ORG_ROLE.MEMBER,

      // Workspace role checks
      isWorkspaceAdmin: workspaceRole === WORKSPACE_ROLE.ADMIN,
      isWorkspaceMember: workspaceRole === WORKSPACE_ROLE.MEMBER,
      isWorkspaceAgent: workspaceRole === WORKSPACE_ROLE.AGENT,
    };
  }, [loggedInUser, activeWorkspaceId]);
};
